import * as React from "react";
import { Button, Tooltip } from "@mui/material";
import PillButtonGroup from "./PillButtonGroup";

const segmentSx = (active, disabled) => ({
  flex: 1,
  py: 1,
  fontWeight: active ? 600 : 400,
  backgroundColor: active ? "#EBEBEB" : "transparent",
  color: disabled ? "#9e9e9e" : "#333",
  px: { xs: 1, sm: 2 },
  fontSize: { xs: "0.75rem", sm: "0.875rem" },
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: disabled ? "transparent" : active ? "#EBEBEB" : "#f5f5f5",
  },
});

// Pill-style tab bar built on the existing PillButtonGroup, styled to match
// SegmentedStatusFilter's active/inactive treatment. Stretches full width with
// evenly-sized segments. Disabled tabs are truly unclickable (native
// `disabled`, not just visually dimmed) and explain why via a tooltip.
export default function WorkspaceTabs({ tabs, value, onChange }) {
  return (
    <PillButtonGroup
      sx={{
        display: "flex",
        width: "100%",
        p: 0.5,
        overflowX: "auto",
        "& > button": { borderRadius: 1, textTransform: "none" },
      }}
    >
      {tabs.map((tab) => (
        <Tooltip
          key={tab.key}
          title={tab.disabled ? tab.disabledReason || "" : ""}
          arrow
          disableHoverListener={!tab.disabled}
        >
          <span style={{ flex: 1, display: "flex" }}>
            <Button
              variant="text"
              disabled={tab.disabled}
              onClick={() => {
                if (!tab.disabled) onChange(tab.key);
              }}
              sx={segmentSx(value === tab.key, tab.disabled)}
            >
              {tab.label}
            </Button>
          </span>
        </Tooltip>
      ))}
    </PillButtonGroup>
  );
}
